export default __webpack_public_path__ + "static/media/insta_dexpro1.a3fc3569.png";